import { LuIcon, Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, type ReactElement } from "react"

import { SelectItemTemplate } from "../../../components/MenuGroups/constants"
import { HeadingLevel } from "../../enums"
import { headingDataMapping } from "../mappings"

type HeadingDropdownSelectProps = Omit<MenuRootProps, "children"> &
	Omit<MenuClickTriggerProps, "children"> &
	MenuVariantProps &
	ComponentPropsWithRef<typeof Menu.SelectGroup<HeadingLevel>> & {
		levels: HeadingLevel[]
		children: ReactElement
	}

export const HeadingDropdownSelect = memo<HeadingDropdownSelectProps>((props) => {
	const {
		// Trigger props
		disabled = false,
		children,
		// MenuContent props
		radius,
		size,
		variant,
		accentColor,
		// HeadingSelectGoup props
		levels,
		value,
		defaultValue,
		onValueChange,
		required,
		...rest
	} = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content size={size} radius={radius} accentColor={accentColor} variant={variant}>
				{/* @ts-expect-error cant have invalid mismatch */}
				<Menu.SelectGroup<HeadingLevel>
					required={required}
					value={value}
					defaultValue={defaultValue}
					onValueChange={onValueChange}
				>
					<Menu.Label>Headings</Menu.Label>
					{levels.map((level) => {
						const { label, icon } = headingDataMapping[level]
						return (
							<SelectItemTemplate<HeadingLevel> value={level} key={level}>
								<LuIcon icon={icon} />
								{label}
							</SelectItemTemplate>
						)
					})}
				</Menu.SelectGroup>
			</Menu.Content>
		</Menu.Root>
	)
})
HeadingDropdownSelect.displayName = "HeadingDropdownSelect"
